import { map, sum } from 'lodash';
import { DurationRead } from 'app/components/Duration/Duration';
import { getResources } from 'app/store/selectors/getResources.js';
export const getTaskTimeReal = (state, taskId) => {
    const task = getResources(state, 'tasks', taskId, ['activitiesInst']);
    const duration = sum(map(task.activitiesInst, (activity) => activity.duration));
    return DurationRead({ value: duration });
};
